module.exports = __webpack_public_path__ + "media/dogs/barking-dalmatian-aef3908c.svg";